import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsKachelIconEnergieV1(props: SVGProps<SVGSVGElement>) {
  return <svg
    data-name="Ebene 1"
    viewBox="0 0 73 52"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.41 50.66a4.19 4.19 0 0 1-3.22-1.51 4.38 4.38 0 0 1-.95-3.46c0-.06.02-.11.04-.17l3.67-12.51-5.11 2.14c-.06.03-.13.05-.19.06-1.85.44-3.85-.45-4.77-2.15-.74-1.36-.71-3.03.07-4.36L36.52 3.44c.82-1.35 2.15-2.11 3.62-2.11 1.33 0 2.59.65 3.38 1.72.72.98.98 2.23.73 3.43L40 21.03l6.14-2.13s.1-.03.14-.04c1.75-.38 3.62.46 4.52 2.02.74 1.29.76 2.91.05 4.23l-.08.15s-.05.08-.05.09l-7.94 12.29c-.37.58-1.15.75-1.73.37-.58-.37-.75-1.15-.37-1.73l7.94-12.29c.35-.63.34-1.31.03-1.86-.36-.62-1.07-.96-1.76-.84l-8.35 2.9c-.44.15-.93.05-1.27-.27-.34-.32-.47-.81-.34-1.26l4.91-16.78c.08-.4-.03-.94-.33-1.35-.32-.44-.83-.7-1.36-.7-.59 0-1.12.31-1.44.83l-14.6 25.31c-.35.59-.36 1.32-.04 1.91.38.69 1.16 1.07 1.91.93l7.42-3.11a1.253 1.253 0 0 1 1.69 1.5L30.7 46.14c-.06.52.08 1.02.41 1.4.33.39.8.61 1.31.61.59 0 1.14-.31 1.45-.83l3.52-5.45c.38-.58 1.15-.74 1.73-.37.58.38.75 1.15.37 1.73l-3.5 5.42c-.74 1.23-2.12 2-3.57 2Z"
      style={{
        fill: '#f6ad81',
      }}
    />
  </svg>
}
export default SvgMsKlimadashboardIconsKachelIconEnergieV1
